<template>
  <wide-box-section-empty :style="{ backgroundImage: 'url(' + require('../assets/trust.svg') + ')' }" class="approach-content">
    <div class="left-column">
      <h1>Our Approach</h1>
      <p>Who hasn’t been driven up the walls by nitpicking auditors who miss the big picture and focus on unimportant details?</p>
    </div>
    <div class="right-column">
      <p>At AuditLink, it’s not all about standards and test sheets - it's about trust.</p>
      <p>Our clients trust us to deliver effective and efficient audits, and they benefit from the insights we can share with them thanks to our specialised methodology.</p>
      <h3>The other cornerstone of our approach is risk assessment.</h3>
      <p>By concentrating on risks, we reduce detailed testing and instead focus on the transactions and events that are most relevant from a management and audit point of view. We work hard to ensure we have an in-depth understanding of our clients, which makes all this possible.</p>
      <p>An AuditLink audit is much more than just a statutory responsibility - it’s a chance to get expert assistance that will help your organisation improve and be better prepared to meet its goals.</p>
    </div>
  </wide-box-section-empty>
</template>

<script>
import WideBoxSectionEmpty from './WideBoxSectionEmpty'
export default {
  name: 'Services',
  components: { WideBoxSectionEmpty },

  metaInfo () {
    return {
      title: this.metaInfo.title
    }
  },

  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      metaInfo: {
        title: 'Our Approach'
      }
    }
  },

  mounted () {
    document.dispatchEvent(new Event('content-loaded'))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Approach.vue